import type { Definition } from '~/types'
import imageSizes from '../../constants/imageSizes'

export const ModuleTerminalHardwareSpecs: Definition = {
  contentType: 'ModuleTerminalHardwareSpecs',
  fields: [
    {
      id: 'dimensions',
      name: 'Dimensions (size)',
      type: 'Symbol'
    },
    // {
    //   id: 'deviceVariant',
    //   name: 'Device variant',
    //   type: 'Symbol',
    //   hideCompare: true
    // },
    {
      id: 'printer',
      name: 'Printer Availability',
      type: 'Boolean'
    },
    {
      id: 'userInterface',
      name: 'User Interface',
      type: 'Symbol'
    },
    {
      id: 'paperRollSize',
      name: 'Paper roll size',
      type: 'Symbol'
    },
    {
      id: 'speakerAudio',
      name: 'Speaker + audio jack',
      type: 'Boolean',
      hideCompare: true
    },
    {
      id: 'powerSupply',
      name: 'Power Supply (PSU)',
      type: 'Symbol'
    },
    {
      id: 'weight',
      name: 'Weight',
      type: 'Symbol'
    },
    {
      id: 'battery',
      name: 'Battery type',
      type: 'Symbol'
    },
    {
      id: 'processor',
      name: 'Processor',
      type: 'Symbol'
    },
    {
      id: 'memory',
      name: 'Memory',
      type: 'Symbol'
    },
    {
      id: 'operatingSystem',
      name: 'Operating system',
      type: 'Symbol'
    },
    {
      id: 'camerabarcodeScanner',
      name: 'Camera or Barcode Scanner',
      type: 'Symbol'
    },
    {
      id: 'pciValidity',
      name: 'PCI Validity',
      type: 'Symbol'
    },
    {
      id: 'p2pe',
      name: 'Point-to-Point Encryption (P2PE)',
      type: 'Symbol'
    }
  ]
}
export const ModuleTerminalConnectivitySpecs: Definition = {
  contentType: 'ModuleTerminalConnectivitySpecs',
  fields: [
    {
      id: 'ethernet',
      name: 'Ethernet',
      type: 'Symbol'
    },
    {
      id: 'connectivity4G',
      name: '4G',
      type: 'Boolean'
    },
    {
      id: 'wifi',
      name: 'Wifi',
      type: 'Boolean'
    },
    {
      id: 'bluetooth',
      name: 'Bluetooth',
      type: 'Symbol'
    }
  ]
}
export const ModuleTerminalPaymentExperienceSpecs: Definition = {
  contentType: 'ModuleTerminalPaymentExperienceSpecs',
  fields: [
    {
      id: 'giftcards',
      name: 'Accepts giftcards',
      type: 'Boolean'
    },
    {
      id: 'debitCredit',
      name: 'Accepts debit/credit cards',
      type: 'Boolean'
    },
    {
      id: 'localPaymentMehtods',
      name: 'Accepts local payment methods',
      type: 'Boolean'
    },
    {
      id: 'ewallets',
      name: 'Accepts e-wallets',
      type: 'Boolean'
    },
    {
      id: 'recurringPayments',
      name: 'Customer recognition & recurring payments',
      type: 'Boolean'
    },
    {
      id: 'dcc',
      name: 'Dynamic currency conversion',
      type: 'Boolean'
    },
    {
      id: 'tips',
      name: 'Supports tips',
      type: 'Boolean'
    },
    {
      id: 'languages',
      name: 'Supports language customization',
      type: 'Boolean'
    },
    {
      id: 'custom',
      name: 'Supports custom screen & logo',
      type: 'Boolean'
    },
    {
      id: 'taxfree',
      name: 'Tax free shopping',
      type: 'Boolean'
    },
    {
      id: 'contactlessOnly',
      name: 'Contactless only',
      type: 'Boolean'
    },
    {
      id: 'chip',
      name: 'Chip & Swipe card available',
      type: 'Boolean'
    },
    {
      id: 'offline',
      name: 'Offline processing',
      type: 'Boolean'
    },
    {
      id: 'standalone',
      name: 'Standalone',
      type: 'Boolean'
    },
    {
      id: 'walletPasses',
      name: 'Wallet passes',
      type: 'Boolean'
    },
    {
      id: 'adyenGiving',
      name: 'Adyen Giving',
      type: 'Boolean'
    },
    {
      id: 'surcharging',
      name: 'Surcharging',
      type: 'Boolean'
    },
    {
      id: 'installments',
      name: 'Installments',
      type: 'Boolean'
    },
    {
      id: 'nfcTags',
      name: 'NFC tags reading and writing',
      type: 'Boolean'
    },
    {
      id: 'accessibleAudioGuide',
      name: 'Accessible Audio Guide',
      type: 'Boolean'
    },
    {
      id: 'payAtTable',
      name: 'Pay@Table',
      type: 'Boolean'
    },
    {
      id: 'cashback',
      name: 'Cashback',
      type: 'Boolean'
    }
  ]
}
export const ModuleTerminalIntegrationSpecs: Definition = {
  contentType: 'ModuleTerminalIntegrationSpecs',
  fields: [
    {
      id: 'terminalApi',
      name: 'Terminal API (cloud/local/general)',
      type: 'Boolean'
    },
    {
      id: 'appIntegration',
      name: 'Adyens Payment SDK',
      type: 'Boolean'
    },
    {
      id: 'androidAPI',
      name: 'Terminal API - Android payment application',
      type: 'Boolean'
    }
  ]
}
export const BlockTerminalSpecs: Definition = {
  contentType: 'BlockTerminalSpecs',
  fields: [
    {
      id: 'hardwareTitle',
      name: 'Hardware section title',
      type: 'Symbol'
    },
    {
      id: 'hardware',
      name: 'Hardware specs',
      type: 'Array',
      validations: [
        {
          size: {
            min: 1,
            max: 3
          }
        }
      ],
      subType: 'ModuleTerminalHardwareSpecs'
    },
    {
      id: 'connectivityTitle',
      name: 'Connectivity section title',
      type: 'Symbol'
    },
    {
      id: 'connectivity',
      name: 'Connectivity specs',
      type: 'Array',
      subType: 'ModuleTerminalConnectivitySpecs',
      validations: [
        {
          size: {
            min: 1,
            max: 1
          }
        }
      ]
    },
    {
      id: 'paymentExperienceTitle',
      name: 'Payment experience section title',
      type: 'Symbol'
    },
    {
      id: 'paymentExperience',
      name: 'Payment experience specs',
      type: 'Array',
      subType: 'ModuleTerminalPaymentExperienceSpecs',
      validations: [
        {
          size: {
            min: 1,
            max: 1
          }
        }
      ]
    },
    {
      id: 'integrationTitle',
      name: 'Integration section title',
      type: 'Symbol'
    },
    {
      id: 'integration',
      name: 'Integration specs',
      type: 'Array',
      subType: 'ModuleTerminalIntegrationSpecs',
      validations: [
        {
          size: {
            min: 1,
            max: 1
          }
        }
      ]
    }
  ]
}
export const TerminalsLabels: Definition = {
  contentType: 'TerminalsLabels',
  fields: [
    {
      id: 'terminal',
      name: 'Terminal',
      type: 'Symbol'
    },
    {
      id: 'goToDevice',
      name: 'Go to device',
      type: 'Symbol'
    },
    {
      id: 'select',
      name: 'Select',
      type: 'Symbol'
    },
    {
      id: 'remove',
      name: 'Remove',
      type: 'Symbol'
    },
    {
      id: 'compareTerminals',
      name: 'Compare terminals',
      type: 'Symbol'
    },
    {
      id: 'compare',
      name: 'Compare',
      type: 'Symbol'
    },
    {
      id: 'cancel',
      name: 'Cancel',
      type: 'Symbol'
    },
    {
      id: 'addUpTo',
      name: 'Add up to',
      type: 'Symbol'
    },
    {
      id: 'hardware',
      name: 'Hardware',
      type: 'Symbol'
    },
    {
      id: 'connectivity',
      name: 'Connectivity',
      type: 'Symbol'
    },
    {
      id: 'paymentExperience',
      name: 'Payment experience',
      type: 'Symbol'
    },
    {
      id: 'Integration',
      name: 'Integration',
      type: 'Symbol'
    },
    {
      id: 'geographicalAvailability',
      name: 'Geographical Availability',
      type: 'Symbol',
      defaultValue: {
        en: 'Geographical availability'
      }
    }
  ]
}
export const TerminalsLabelsHardwareSpecs: Definition = {
  contentType: 'TerminalsLabelsHardwareSpecs',
  fields: [
    {
      id: 'dimensions',
      name: 'Dimensions (size)',
      type: 'Boolean',
      defaultValue: {
        en: 'Dimensions (size)'
      }
    },
    {
      id: 'printer',
      name: 'Printer Availability',
      type: 'Symbol',
      defaultValue: {
        en: 'Printer Availability'
      }
    },
    {
      id: 'userInterface',
      name: 'User Interface',
      type: 'Symbol',
      defaultValue: {
        en: 'User interface'
      }
    },
    {
      id: 'paperRollSize',
      name: 'Paper roll size',
      type: 'Symbol',
      defaultValue: {
        en: 'Paper roll size'
      }
    },
    {
      id: 'speakerAudio',
      name: 'Speaker + audio jack',
      type: 'Symbol',
      defaultValue: {
        en: 'Speaker + audio jack'
      }
    },
    {
      id: 'weight',
      name: 'Weight',
      type: 'Symbol',
      defaultValue: {
        en: 'Weight'
      }
    },
    {
      id: 'battery',
      name: 'Battery',
      type: 'Symbol',
      defaultValue: {
        en: 'Battery'
      }
    },
    {
      id: 'processor',
      name: 'Processor',
      type: 'Symbol',
      defaultValue: {
        en: 'Processor'
      }
    },
    {
      id: 'memory',
      name: 'Memory',
      type: 'Symbol',
      defaultValue: {
        en: 'Memory'
      }
    },
    {
      id: 'powerSupply',
      name: 'Power Supply (PSU)',
      type: 'Symbol',
      defaultValue: {
        en: 'Power supply'
      }
    },
    {
      id: 'operatingSystem',
      name: 'Operating system',
      type: 'Symbol',
      defaultValue: {
        en: 'Operating System'
      }
    },
    {
      id: 'camerabarcodeScanner',
      name: 'Camera or Barcode Scanner',
      type: 'Symbol',
      defaultValue: {
        en: 'Camera Scanner'
      }
    },
    {
      id: 'pciValidity',
      name: 'PCI validity',
      type: 'Symbol',
      defaultValue: {
        en: 'PCI Validity'
      }
    },
    {
      id: 'pciValidityFilter',
      name: 'PCI Validity Filter Label',
      type: 'Symbol',
      defaultValue: {
        en: 'PCI Validity'
      }
    }
  ]
}
export const TerminalsLabelsConnectivitySpecs: Definition = {
  contentType: 'TerminalsLabelsConnectivitySpecs',
  fields: [
    {
      id: 'ethernet',
      name: 'Ethernet',
      type: 'Symbol',
      defaultValue: {
        en: 'Ethernet'
      }
    },
    {
      id: 'connectivity4G',
      name: '4G',
      type: 'Symbol',
      defaultValue: {
        en: '4G'
      }
    },
    {
      id: 'wifi',
      name: 'Wifi',
      type: 'Symbol',
      defaultValue: {
        en: 'Wifi'
      }
    },
    {
      id: 'bluetooth',
      name: 'Bluetooth',
      type: 'Symbol',
      defaultValue: {
        en: 'Bluetooth'
      }
    },
    {
      id: 'ethernetValueYes',
      name: 'Ethernet Yes',
      type: 'Symbol',
      defaultValue: {
        en: 'Yes'
      }
    },
    {
      id: 'ethernetValueYesWithBaseStation',
      name: 'Ethernet Yes With Base Station',
      type: 'Symbol',
      defaultValue: {
        en: 'Yes, with base station required'
      }
    },
    {
      id: 'ethernetValueNo',
      name: 'Ethernet No',
      type: 'Symbol',
      defaultValue: {
        en: 'No'
      }
    }
  ]
}
export const TerminalsLabelsPaymentExperienceSpecs: Definition = {
  contentType: 'TerminalsLabelsPaymentExperienceSpecs',
  fields: [
    {
      id: 'giftcards',
      name: 'Accepts giftcards',
      type: 'Symbol',
      defaultValue: {
        en: 'Accepts giftcards'
      }
    },
    {
      id: 'debitCredit',
      name: 'Accepts debit/credit cards',
      type: 'Symbol',
      defaultValue: {
        en: 'Accepts debit/credit cards'
      }
    },
    {
      id: 'localPaymentMehtods',
      name: 'Accepts local payment methods',
      type: 'Symbol',
      defaultValue: {
        en: 'Accepts local payment methods'
      }
    },
    {
      id: 'ewallets',
      name: 'Accepts e-wallets',
      type: 'Symbol',
      defaultValue: {
        en: 'Accepts e-wallets'
      }
    },
    {
      id: 'recurringPayments',
      name: 'Customer recognition & recurring payments',
      type: 'Symbol',
      defaultValue: {
        en: 'Customer recognition & recurring payments'
      }
    },
    {
      id: 'dcc',
      name: 'Dynamic currency conversion',
      type: 'Symbol',
      defaultValue: {
        en: 'Dynamic currency conversion'
      }
    },
    {
      id: 'tips',
      name: 'Supports tips',
      type: 'Symbol',
      defaultValue: {
        en: 'Supports tips'
      }
    },
    {
      id: 'languages',
      name: 'Supports language customization',
      type: 'Symbol',
      defaultValue: {
        en: 'Supports language customization'
      }
    },
    {
      id: 'custom',
      name: 'Supports custom screen & logo',
      type: 'Symbol',
      defaultValue: {
        en: 'Supports custom screen & logo'
      }
    },
    {
      id: 'taxfree',
      name: 'Tax free shopping',
      type: 'Symbol',
      defaultValue: {
        en: 'Tax free shopping'
      }
    },
    {
      id: 'contactless',
      name: 'Contactless only',
      type: 'Symbol',
      defaultValue: {
        en: 'Contactless'
      }
    },
    {
      id: 'chip',
      name: 'Chip & Swipe card available',
      type: 'Symbol',
      defaultValue: {
        en: 'Chip & Swipe card availability'
      }
    },
    {
      id: 'offline',
      name: 'Offline Processing',
      type: 'Symbol',
      defaultValue: {
        en: 'Offline Processing'
      }
    },
    {
      id: 'standalone',
      name: 'Standalone',
      type: 'Symbol',
      defaultValue: {
        en: 'Standalone'
      }
    },
    {
      id: 'walletPasses',
      name: 'Wallet passes',
      type: 'Symbol',
      defaultValue: {
        en: 'Wallet passes'
      }
    },
    {
      id: 'adyenGiving',
      name: 'Adyen Giving',
      type: 'Symbol',
      defaultValue: {
        en: 'Adyen Giving'
      }
    },
    {
      id: 'surcharging',
      name: 'Surcharging',
      type: 'Symbol',
      defaultValue: {
        en: 'Surcharging'
      }
    },
    {
      id: 'installments',
      name: 'Installments',
      type: 'Symbol',
      defaultValue: {
        en: 'Installments'
      }
    },
    {
      id: 'nfcTags',
      name: 'NFC tags reading and writing',
      type: 'Symbol',
      defaultValue: {
        en: 'NFC tags reading and writing'
      }
    },
    {
      id: 'accessibleAudioGuide',
      name: 'Accessible Audio Guide',
      type: 'Symbol',
      defaultValue: {
        en: 'Accessible Audio Guide'
      }
    },
    {
      id: 'payAtTable',
      name: 'Pay@Table',
      type: 'Symbol',
      defaultValue: {
        en: 'Pay@Table'
      }
    },
    {
      id: 'cashback',
      name: 'Cashback',
      type: 'Symbol',
      defaultValue: {
        en: 'Cashback'
      }
    }
  ]
}
export const TerminalsLabelsIntegrationSpecs: Definition = {
  contentType: 'TerminalsLabelsIntegrationSpecs',
  fields: [
    {
      id: 'terminalAPI',
      name: 'Terminal API (cloud/local/general)',
      type: 'Symbol',
      defaultValue: {
        en: 'Terminal API (cloud/local/general)'
      }
    },
    {
      id: 'appIntegration',
      name: 'Adyens Payment SDK',
      type: 'Symbol',
      defaultValue: {
        en: 'Adyens Payment SDK'
      }
    },
    {
      id: 'androidAPI',
      name: 'Terminal API - Android payment application',
      type: 'Symbol',
      defaultValue: {
        en: 'Terminal API - Android payment application'
      }
    }
  ]
}

export const PageTerminalsDetail: Definition = {
  contentType: 'PageTerminalsDetail',
  fields: [
    {
      id: 'terminalName',
      name: 'Terminal name',
      type: 'Symbol',
      includeInParent: true
    },
    {
      id: 'terminalDescription',
      name: 'Terminal description',
      type: 'Text',
      includeInParent: true
    },
    {
      id: 'specialTag',
      name: 'Special tag to display (ex: Only US)',
      type: 'Symbol',
      includeInParent: true
    },
    {
      id: 'terminalCategory',
      name: 'Terminal category (DELETE)',
      type: 'Symbol',
      includeInParent: true,
      localized: false,
      validations: [{ in: ['MOBILE', 'PORTABLE', 'COUNTERTOP', 'UNATTENDED'] }]
    },
    {
      id: 'salesLink',
      name: 'Sales link',
      type: 'ModuleNavigationLink'
    },
    {
      id: 'benefits',
      name: 'Benefits',
      type: 'Array',
      subType: 'ModuleUsp'
    },
    {
      id: 'primaryImage',
      name: 'Primary image for the device',
      type: 'ModuleMedia',
      includeInParent: true,
      imageOptions: { sizes: imageSizes.columns5_34, lazy: true }
    },
    // Check if secondaryImage is needed
    {
      id: 'secondaryImage',
      name: 'Secondary image for the device',
      type: 'ModuleMedia',
      includeInParent: true,
      imageOptions: { sizes: imageSizes.columns5_34, lazy: true }
    },
    {
      id: 'thumbnailImage',
      name: 'Image for the comparison grid',
      type: 'ModuleMedia',
      includeInParent: true,
      imageOptions: { sizes: imageSizes.terminals_grid, lazy: true }
    },
    {
      id: 'introMediaTitle',
      name: 'Intro Media Title',
      type: 'Symbol'
    },
    {
      id: 'introMediaDescription',
      name: 'Intro Media Description',
      type: 'Symbol'
    },
    {
      id: 'introMediaAutoPlay',
      name: 'Intro Media Auto Play',
      type: 'Boolean'
    },
    {
      id: 'introMedia',
      name: 'Intro media',
      type: ['ModuleVideo', 'ModuleInternalVideo'],
      imageOptions: { sizes: imageSizes.columns12_52, lazy: true }
    },
    {
      id: 'logoBar',
      name: 'Logo bar',
      type: 'BlockLogoBar'
    },
    {
      id: 'quote',
      name: 'Quote',
      type: 'BlockSimpleQuote'
    },
    {
      id: 'specsTitle',
      name: 'Specs title',
      type: 'Symbol'
    },
    {
      id: 'specs',
      name: 'Specs',
      type: 'BlockTerminalSpecsLazy',
      lazy: true
    },
    {
      id: 'cta',
      name: 'Call to action',
      type: 'BlockCallToAction'
    },
    {
      id: 'formId',
      name: 'Form ID',
      type: 'Symbol'
    },
    {
      id: 'formTitle',
      name: 'Form Title',
      type: 'Symbol'
    },
    {
      id: 'formDescription',
      name: 'Form Description',
      type: 'Symbol'
    },
    {
      id: 'footnotes',
      name: 'Footnotes',
      type: 'RichText'
    },
    {
      id: 'contentBlock1',
      name: 'Content Block 1',
      type: 'BlockGroup',
      subType: 'BlockContent'
    },
    {
      id: 'highlighted',
      name: 'Highlight',
      type: 'Boolean',
      includeInParent: true
    },
    {
      id: 'awardImage1',
      name: 'Award Image 1',
      type: 'ModuleMedia'
    },
    {
      id: 'awardImage2',
      name: 'Award Image 2',
      type: 'ModuleMedia'
    },
    {
      id: 'industries',
      name: 'Industries',
      type: 'Array',
      subType: 'GlobalDataIndustry',
      validations: [{ size: { min: 0, max: 10 } }],
      includeInParent: true
    },
    {
      id: 'industriesTitle',
      name: 'Industries Title',
      type: 'Symbol',
      localized: true
    },
    {
      id: 'deviceType',
      name: 'Device Type',
      type: 'GlobalDataDeviceType',
      includeInParent: true
    },
    {
      id: 'countryAvailability',
      name: 'Country Availability',
      type: 'Array',
      subType: 'GlobalDataCountry',
      validations: [{ size: { min: 0, max: 20 } }],
      includeInParent: true
    },
    {
      id: 'useCases',
      name: 'Use cases',
      type: 'BlockMediaCardGroup',
      imageOptions: { sizes: imageSizes.columns6_43, lazy: true }
    },
    {
      id: 'accessories',
      name: 'Accessories',
      type: 'BlockMediaCardGroup',
      validations: [{ size: { min: 0, max: 3 } }],
      imageOptions: { sizes: imageSizes.columns6_43, lazy: true }
    },
    {
      id: 'displayComparisonTabs',
      name: 'Display Comparison Tabs',
      type: 'BlockGroup',
      subType: 'BlockTabContentLazy',
      lazy: true,
      imageOptions: { sizes: imageSizes.columns12_21, lazy: true }
    }
  ]
}

export const PageTerminalsComparison: Definition = {
  contentType: 'PageTerminalsComparison',
  fields: [
    {
      id: 'backLink',
      name: 'Back link',
      type: 'ModuleNavigationLink'
    },
    {
      id: 'titleLabel',
      name: 'Title label',
      type: 'Symbol'
    },
    {
      id: 'cta',
      name: 'Call to action',
      type: 'BlockCallToAction'
    }
  ]
}

export const PageTerminals: Definition = {
  contentType: 'PageTerminals',
  fields: [
    {
      id: 'backLink',
      name: 'Back link',
      type: 'ModuleNavigationLink'
    },
    {
      id: 'titleLabel',
      name: 'Title label',
      type: 'Symbol'
    },
    {
      id: 'description',
      name: 'Description',
      localized: true,
      type: 'Symbol'
    },
    {
      id: 'compareLink',
      name: 'Compare link',
      type: 'ModuleNavigationLink'
    },
    {
      id: 'faq',
      name: 'FAQ',
      localized: true,
      type: 'BlockFaqGroup'
    }
  ]
}

export const PageTerminalsDetailRelated: Definition = {
  contentType: 'PageTerminalsDetail',
  fields: [
    {
      id: 'terminalName',
      name: 'Terminal name',
      type: 'Symbol',
      includeInParent: true
    },
    {
      id: 'terminalDescription',
      name: 'Terminal description',
      type: 'Text',
      includeInParent: true
    },
    {
      id: 'specialTag',
      name: 'Special tag to display (ex: Only US)',
      type: 'Symbol',
      includeInParent: true
    },
    {
      id: 'terminalCategory',
      name: 'Terminal category (DELETE)',
      type: 'Symbol',
      includeInParent: true,
      localized: false,
      validations: [{ in: ['MOBILE', 'PORTABLE', 'COUNTERTOP', 'UNATTENDED'] }]
    },
    {
      id: 'primaryImage',
      name: 'Primary image for the device',
      type: 'ModuleMedia',
      includeInParent: true,
      imageOptions: { sizes: imageSizes.columns5_34, lazy: true }
    },
    {
      id: 'secondaryImage',
      name: 'Secondary image for the device',
      type: 'ModuleMedia',
      includeInParent: true,
      imageOptions: { sizes: imageSizes.columns5_34, lazy: true }
    },
    {
      id: 'thumbnailImage',
      name: 'Image for the comparison grid',
      type: 'ModuleMedia',
      includeInParent: true,
      imageOptions: { sizes: imageSizes.terminals_grid, lazy: true }
    },
    {
      id: 'specsTitle',
      name: 'Specs title',
      type: 'Symbol'
    },
    {
      id: 'specs',
      name: 'Specs',
      type: 'BlockTerminalSpecsLazy',
      lazy: true
    },
    {
      id: 'highlighted',
      name: 'Highlight',
      type: 'Boolean',
      includeInParent: true
    },
    {
      id: 'industries',
      name: 'Industries',
      type: 'Array',
      subType: 'GlobalDataIndustry',
      validations: [{ size: { min: 0, max: 10 } }],
      includeInParent: true
    },
    {
      id: 'industriesTitle',
      name: 'Industries Title',
      type: 'Symbol',
      localized: true
    },
    {
      id: 'deviceType',
      name: 'Device Type',
      type: 'GlobalDataDeviceType',
      includeInParent: true
    },
    {
      id: 'countryAvailability',
      name: 'Country Availability',
      type: 'Array',
      subType: 'GlobalDataCountry',
      validations: [{ size: { min: 0, max: 20 } }],
      includeInParent: true
    }
  ]
}

export default {
  TerminalsLabels,
  TerminalsLabelsHardwareSpecs,
  TerminalsLabelsConnectivitySpecs,
  TerminalsLabelsPaymentExperienceSpecs,
  TerminalsLabelsIntegrationSpecs,

  ModuleTerminalIntegrationSpecs,
  ModuleTerminalPaymentExperienceSpecs,
  ModuleTerminalConnectivitySpecs,
  ModuleTerminalHardwareSpecs,
  BlockTerminalSpecs,

  PageTerminals,
  PageTerminalsComparison,
  PageTerminalsDetail,
  PageTerminalsDetailRelated
}
